/* eslint-disable complexity */
import { Injectable } from '@angular/core';
import {
  BookWidgetFieldUpdateTypes,
  SearchModalEvent,
  SearchModalEventType
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Store } from '@ngrx/store';
import * as fromBookWidgetActions from '../+state/actions/book-widget.actions';
import * as fromSavedSearchActions from '../+state/actions/saved-search.actions';
import * as fromSearchModalSelectors from '../+state/selectors/search-modal.selectors';
import { isAirportSearchStringValid } from '../adapters/utils/utils.adapter';
@Injectable({ providedIn: 'root' })
export class SearchModalFacade {
  searchModalTabs$ = this.store.select(
    fromSearchModalSelectors.getSearchModalTabs
  );

  searchModalRecentSearchList$ = this.store.select(
    fromSearchModalSelectors.getSearchModalRecentSearchList
  );

  searchModalSavedSearchList$ = this.store.select(
    fromSearchModalSelectors.getSearchModalSavedSearchList
  );

  searchModalPredictiveSearchList$ = this.store.select(
    fromSearchModalSelectors.getSearchModalPredictiveSearchList
  );

  constructor(private store: Store) {}

  handleSearchModalEvent(event: SearchModalEvent<SearchModalEventType>) {
    switch (event.type) {
      case 'predictiveSearchItemSelected':
        if (event.data.locationType === 'origin') {
          this.store.dispatch(
            fromBookWidgetActions.BookWidgetFieldChange({
              bookWidgetFieldUpdateEvent: {
                type: BookWidgetFieldUpdateTypes.originAirport,
                data: {
                  airportCity: event.data.airportCity,
                  airportCode: event.data.airportCode,
                  flightIndex: event.data.flightIndex
                }
              }
            })
          );
        } else if (event.data.locationType === 'destination') {
          this.store.dispatch(
            fromBookWidgetActions.BookWidgetFieldChange({
              bookWidgetFieldUpdateEvent: {
                type: BookWidgetFieldUpdateTypes.destinationAirport,
                data: {
                  airportCity: event.data.airportCity,
                  airportCode: event.data.airportCode,
                  flightIndex: event.data.flightIndex
                }
              }
            })
          );
        } else {
          this.store.dispatch(
            fromBookWidgetActions.BookWidgetFieldChange({
              bookWidgetFieldUpdateEvent: {
                type: BookWidgetFieldUpdateTypes.connectionAirport,
                data: {
                  airportCity: event.data.airportCity,
                  airportCode: event.data.airportCode,
                  flightIndex: event.data.flightIndex
                }
              }
            })
          );
        }
        break;
      case 'recentSearchItemSelected':
        this.store.dispatch(
          fromBookWidgetActions.RecentSearchItemSelected({ index: event.data })
        );
        break;
      case 'saveSearchItemSelected':
        this.store.dispatch(
          fromBookWidgetActions.SavedSearchItemSelected({ index: event.data })
        );
        break;
      case 'searchStringChanged':
        if (isAirportSearchStringValid(event.data)) {
          this.store.dispatch(
            fromBookWidgetActions.InitPredictiveSearch({
              predictiveSearchString: event.data.toUpperCase()
            })
          );
        }
        break;
      case 'modalOpen':
        this.store.dispatch(fromBookWidgetActions.SearchModalOpened());
        this.store.dispatch(fromSavedSearchActions.LoadSavedSearch());
        break;
    }
  }
}
